module.exports = __webpack_public_path__ + "bc941efe07a1529c3112060ccdb86a07.png";